//---Handle Access Token---
const ACCESS_TOKEN = "access_token"
export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN)
export const setAccessToken = (token: string) => localStorage.setItem(ACCESS_TOKEN, token)
export const removeAccessToken = () => localStorage.removeItem(ACCESS_TOKEN)

const REFRESH_TOKEN = "refresh_token"
export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN)
export const setRefreshToken = (token: string) => localStorage.setItem(REFRESH_TOKEN, token)
export const removeRefreshToken = () => localStorage.removeItem(REFRESH_TOKEN)

export const QUEUE_TOKEN = "queue_token";
export const QUEUE_KEY = "connect_key";
